import { ResponsiveGrid } from '@alifd/next';
import React from 'react';

import PageHeader from '@/components/PageHeader';

import ElevatorFrontDeskList from './components/NewElevatorFrontDeskList';

const { Cell } = ResponsiveGrid;

const ElevatorFrontDesk = () => (
  // <ResponsiveGrid gap={20}>
  //   <Cell colSpan={12}>
  //     <PageHeader
  //       title="電梯列表"
  //       breadcrumbs={[
  //         {
  //           name: '電梯',
  //         },
  //         {
  //           name: '電梯列表',
  //         },
  //       ]}
  //     />
  //   </Cell>

  //   <Cell colSpan={12}>
  //     <ElevatorFrontDeskList />
  //   </Cell>
  // </ResponsiveGrid>
  <ElevatorFrontDeskList />
);

export default ElevatorFrontDesk;
